import * as React from 'react';
import { Component, RefObject } from 'react';
import { WithMetroLineProps } from 'app/components/metro-line/types';
import { CodeEditSectionType, CodeActionType, CodetableScreen, ReadOnlyConfiguration } from 'app/area/codetable/item/types';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodetableMetadata } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ValidationProps } from 'ui';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { CodetableOptions } from 'app/area/codetable/common';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodetableItemForm } from 'app/area/codetable/item/codetable-item-form';

export type CodeScreenProps = CodeScreenRendererProps;

interface CodeScreenRendererProps extends WithMetroLineProps<CodeEditSectionType> {
  supportedScreens: CodetableScreen[];
  codetableId: number;
  section: string;
  actionType: CodeActionType;
  codeItem: CodeItem;
  originalCodeItem: CodeItem;
  metadata: CodetableMetadata;
  language: CodeComplexValue<number>;
  locale: string;
  translation: CodetableTranslation;
  hasTranslationsToggled: boolean;
  codetableOptions: { [key: string]: CodetableOptions };
  validation: { [key: string]: ValidationProps };
  sectionRef?: RefObject<HTMLDivElement | null>;
  hasBigStickyHeader?: boolean;
  readOnlyConfig?: ReadOnlyConfiguration;
  fetchingParentCategory?: boolean;
  switchTranslationsToggle?: (value: boolean) => void;
}

export class CodeScreenRenderer extends Component<CodeScreenRendererProps> {
  public render() {
    const { supportedScreens, metadata } = this.props;

    const standardRenderer = <CodetableItemForm {...this.props} />;

    if (!supportedScreens || supportedScreens.length === 0 || !metadata || !metadata.codetable
      || !isDefinedIncludingZero(metadata.codetable.id) || !metadata.formName) {
      return standardRenderer;
    }

    const screenToRender = supportedScreens.find(screen => screen.id === metadata.codetable.id && screen.name === metadata.formName);

    if (!screenToRender || !screenToRender.component) {
      return standardRenderer;
    }

    const ScreenComponent = screenToRender.component;

    return <ScreenComponent {...this.props} {...screenToRender.screenProps} screenPayload={screenToRender.screenSlots} />;
  }
}
